__turbopack_context__.v({
  "className": "zen_kaku_gothic_new_b03f93b0-module__NXwGuq__className",
});
